<template>
  <section>
    <gs-header title="Sửa mã giảm giá"
      :breadcrumbs="[
        {title: 'Quản lý mã giảm giá', route: {name: 'promotion'}}
      ]"
    >
    </gs-header>
    <div class="padding-all">
      <el-form :model="localPromotion" :rules="rules" ref="editPromotionForm" label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmitCity('editPromotionForm')">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="24">
            <el-form-item label="Mã giảm giá " prop="code">
              <el-input v-model="localPromotion.code" placeholder="Mã giảm giá"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="adddon-1">
            <el-form-item label="Số tiền " prop="discount">
              <el-input type="number" v-model="localPromotion.discount" placeholder="Số tiền">
                <el-select v-model="localPromotion.is_percent" slot="prepend" placeholder="Đơn vị">
                  <el-option label="đ" :value="false"></el-option>
                  <el-option label="%" :value="true"></el-option>
                </el-select>
                <div slot="append"><span class="text-red"><span v-if="!localPromotion.is_percent">{{localPromotion.discount | vnd}}</span> <span v-else>{{localPromotion.discount}}%</span> </span></div>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Số tiền lớn nhất " prop="max_discount">
              <el-input type="number" v-model="localPromotion.max_discount" placeholder="Số tiền lớn nhất">
                <div slot="append"><span class="text-red">{{localPromotion.max_discount | vnd}}</span></div>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item  label="Số lượng " prop="quantity">
              <el-input type="number" v-model="localPromotion.quantity" placeholder="Số lượng">
                <div slot="append"><span class="text-orange">{{localPromotion.quantity | number}}</span></div>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item label="Áp dụng 1 lần" prop="is_only">
              <el-switch
                v-model="localPromotion.is_only"
                on-text=""
                off-text="">
              </el-switch>
            </el-form-item> -->
            <el-form-item  label="Số lượng áp dụng cho từng user" prop="quantity">
              <el-input type="number" v-model="localPromotion.quantity_per_user" placeholder="Số lượng áp dụng cho từng user">
                <div slot="append"><span class="text-orange">{{localPromotion.quantity_per_user | number}}</span></div>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Ngày bắt đầu" prop="start_date">
              <el-date-picker
                class="width-100"
                v-model="localPromotion.start_date"
                type="date"
                @change="dateFormat('start_date')"
                placeholder="Ngày bắt đầu">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Ngày kết thúc" prop="end_date">
              <el-date-picker
                class="width-100"
                v-model="localPromotion.end_date"
                @change="dateFormat('end_date')"
                type="date"
                placeholder="Ngày kết thúc">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Nguồn đơn" prop="is_active">
              <el-select class="width-100" v-model="localPromotion.source" placeholder="Nguồn đơn">
                <el-option v-for="(source, key, index) in promotionHelpers.sources" :label="source" :value="key.toString()" :key="key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Hãng vận chuyển" prop="carrier_id">
              <el-select class="width-100" v-model="localPromotion.carrier_id" placeholder="Hãng vận chuyển">
                <el-option label="Tất cả" value="0" key="0"></el-option>
                <el-option v-for="carrier in carriers" :label="carrier.name" :value="carrier.id.toString()" :key="carrier.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Tỉnh thành đi" prop="city_from">
              <el-select class="width-100" v-model="localPromotion.city_from" placeholder="Tỉnh thành đi">
                <el-option label="Tất cả" value="0" key="0"></el-option>
                <el-option v-for="city in cities" :label="city.name" :value="city.id.toString()" :key="city.id" v-if="city.allow"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Tỉnh thành đến" prop="city_to">
              <el-select class="width-100" v-model="localPromotion.city_to" placeholder="Tỉnh thành đến">
                <el-option label="Tất cả" value="0" key="0"></el-option>
                <el-option v-for="city in cities" :label="city.name" :value="city.id.toString()" :key="city.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Trạng thái" prop="is_active">
              <el-switch
                v-model="localPromotion.is_active"
                on-text=""
                off-text="">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="Mô tả " prop="description">
              <el-input type="textarea" v-model="localPromotion.description" placeholder="Mô tả"></el-input>
            </el-form-item>
          </el-col>
           <el-col :span="8">
            <el-form-item label="Banner (600x600)">
              <el-upload
                class="avatar-uploader"
                :action="uploadLogoUrl"
                :headers="uploadHeader"
                :show-file-list="false"
                :on-success="handleLogoUpload"
                :before-upload="beforeLogoUpload">
                <img v-if="image.path" :src="image.path" class="banner-promotion">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <button :disabled="submitting" class="ui blue basic small button" native-type="submit">Sửa</button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import { editPromotions, getPromotions } from 'src/api/promotion'
import { head } from 'lodash'
import mixins from './mixins'
import moment from 'moment'
import { formatDate } from 'src/helpers'
export default {
  name: 'EditPromotion',
  mixins: [mixins],
  methods: {
    validateBeforeSubmitCity () {
      this.submitting = true
      this.toggleLoadding()
      this.$refs.editPromotionForm.validate(valid => {
        if (valid) {
          this.localPromotion.start_date = formatDate(this.localPromotion.start_date)
          this.localPromotion.end_date = formatDate(this.localPromotion.end_date)
          this.changedData = false
          this.watching = false
          let dataPost = Object.assign({}, this.localPromotion)
          if (dataPost.carrier_id.toString() === '0') {
            delete dataPost.carrier_id
          }
          if (dataPost.city_from.toString() === '0') {
            delete dataPost.city_from
          }
          if (dataPost.city_to.toString() === '0') {
            delete dataPost.city_to
          }
          dataPost.description = this.simplemde.value()
          editPromotions(this.localPromotion.id, dataPost).then(response => {
            switch (response.code) {
              case 200:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Sửa thành công',
                  body: 'Sửa mã giảm giá thành công'
                })
                this.reloadGsTableAfterRedirect({name: 'promotion'}, 'promotions')
                this.toggleLoadding(false)
                break
              case 422:
                this.submitting = false
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                break
              default:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Không tìm thấy tài nguyên',
                  type: 'warning'
                })
                this.toggleLoadding(false)
            }
          })
        } else {
          this.submitting = false
          this.$store.dispatch('toggleLoadding', false, {root: true})
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          return false
        }
      })
    }
  },
  mounted () {
    getPromotions(this.$route.params.id).then(response => {
      if (response.code === 200) {
        this.simplemde.value(response.data.description ? response.data.description : '')
        this.localPromotion.code = response.data.code
        this.localPromotion.description = response.data.description
        this.localPromotion.discount = response.data.discount.toString()
        this.localPromotion.is_percent = !!response.data.is_percent
        this.localPromotion.max_discount = response.data.max_discount.toString()
        this.localPromotion.quantity = response.data.quantity.toString()
        this.localPromotion.source = response.data.source.toString()
        this.localPromotion.quantity_per_user = response.data.quantity_per_user.toString()
        this.localPromotion.is_only = !!response.data.is_only
        this.localPromotion.carrier_id = response.data.carrier_id.toString()
        this.localPromotion.city_to = response.data.city_to.toString()
        this.localPromotion.city_from = response.data.city_from.toString()
        this.localPromotion.start_date = moment(response.data.start_date, 'DD-MM-YYYY').format()
        this.localPromotion.end_date = moment(response.data.end_date, 'DD-MM-YYYY').format()
        this.localPromotion.is_active = !!response.data.is_active
        this.localPromotion.id = response.data.id
        this.image.path = response.data.image_path
        setTimeout(() => {
          this.watching = true
        }, 100)
      } else {
        this.$router.push({name: 'promotions'})
        this.$store.dispatch('showNotify', {
          title: 'Không tìm thấy tài nguyên',
          body: 'Tài nguyên không tồn tại trên hệ thống',
          type: 'warning'
        })
      }
    })
  }
}
</script>

<style lang="css" scoped>
  .banner-promotion{
    width: 300px;
    height: 300px;
  }
</style>



// WEBPACK FOOTER //
// EditPromotion.vue?64ced30c